import { useErrorStore } from '@/stores/error.ts';

export async function loadAsync(
  status: (loading: boolean) => any,
  promise: () => Promise<void>
) {
  const errorStore = useErrorStore();
  try {
    status(true);
    await promise();
  } catch (error) {
    errorStore.setError(error);
  } finally {
    status(false);
  }
}

export async function loadWithStatusAndErrorHandleAsync(
  status: (loading: boolean) => any,
  promise: () => Promise<void>
) {
  try {
    status(true);
    await loadAndErrorHandleAsync(promise);
  } finally {
    status(false);
  }
}

export async function loadAndErrorHandleAsync(promise: () => Promise<void>) {
  const errorStore = useErrorStore();
  try {
    await promise();
  } catch (error) {
    errorStore.setError(error);
  }
}
